// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension=none"
// @generated from file documents/v3alpha/comments.proto (package com.seed.documents.v3alpha, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, protoInt64, Timestamp } from "@bufbuild/protobuf";
import { BlockNode } from "./documents_pb";

/**
 * Request to create a comment.
 *
 * @generated from message com.seed.documents.v3alpha.CreateCommentRequest
 */
export class CreateCommentRequest extends Message<CreateCommentRequest> {
  /**
   * Requred. Account ID to which the comment is applied.
   *
   * @generated from field: string target_account = 1;
   */
  targetAccount = "";

  /**
   * Required. Path within the account where the comment is applied.
   *
   * @generated from field: string target_path = 2;
   */
  targetPath = "";

  /**
   * Required. Version of the document at the time of the comment.
   *
   * @generated from field: string target_version = 3;
   */
  targetVersion = "";

  /**
   * Optional. When current comment is a reply to another comment,
   * this must be the ID of the comment being replied to.
   * Account and path of the parent comment must be the same as the current comment.
   *
   * @generated from field: string reply_parent = 4;
   */
  replyParent = "";

  /**
   * Required. Content of the comment.
   *
   * @generated from field: repeated com.seed.documents.v3alpha.BlockNode content = 5;
   */
  content: BlockNode[] = [];

  /**
   * Required. Name of the key to use for signing the comment.
   *
   * @generated from field: string signing_key_name = 6;
   */
  signingKeyName = "";

  /**
   * Optional. ID of the capability that allows publishing comments for the target account and path.
   * Anyone can create comments to anything, but having a capability to comment makes sure your comments are propagated along with the content.
   *
   * @generated from field: string capability = 7;
   */
  capability = "";

  constructor(data?: PartialMessage<CreateCommentRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.documents.v3alpha.CreateCommentRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "target_account", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "target_path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "target_version", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "reply_parent", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "content", kind: "message", T: BlockNode, repeated: true },
    { no: 6, name: "signing_key_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "capability", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateCommentRequest {
    return new CreateCommentRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateCommentRequest {
    return new CreateCommentRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateCommentRequest {
    return new CreateCommentRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateCommentRequest | PlainMessage<CreateCommentRequest> | undefined, b: CreateCommentRequest | PlainMessage<CreateCommentRequest> | undefined): boolean {
    return proto3.util.equals(CreateCommentRequest, a, b);
  }
}

/**
 * Request to get a comment.
 *
 * @generated from message com.seed.documents.v3alpha.GetCommentRequest
 */
export class GetCommentRequest extends Message<GetCommentRequest> {
  /**
   * Required. ID of the comment to retrieve.
   * The ID must be a record ID (`{publicKey}/{tsid}`) of the comment.
   * For convenience we also accept versions (CIDs).
   *
   * @generated from field: string id = 1;
   */
  id = "";

  constructor(data?: PartialMessage<GetCommentRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.documents.v3alpha.GetCommentRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetCommentRequest {
    return new GetCommentRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetCommentRequest {
    return new GetCommentRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetCommentRequest {
    return new GetCommentRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetCommentRequest | PlainMessage<GetCommentRequest> | undefined, b: GetCommentRequest | PlainMessage<GetCommentRequest> | undefined): boolean {
    return proto3.util.equals(GetCommentRequest, a, b);
  }
}

/**
 * Request to get multiple comments.
 *
 * @generated from message com.seed.documents.v3alpha.BatchGetCommentsRequest
 */
export class BatchGetCommentsRequest extends Message<BatchGetCommentsRequest> {
  /**
   * Required. List of comment IDs to retrieve.
   * See [GetCommentRequest] for the format of the IDs.
   *
   * @generated from field: repeated string ids = 1;
   */
  ids: string[] = [];

  constructor(data?: PartialMessage<BatchGetCommentsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.documents.v3alpha.BatchGetCommentsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): BatchGetCommentsRequest {
    return new BatchGetCommentsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): BatchGetCommentsRequest {
    return new BatchGetCommentsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): BatchGetCommentsRequest {
    return new BatchGetCommentsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: BatchGetCommentsRequest | PlainMessage<BatchGetCommentsRequest> | undefined, b: BatchGetCommentsRequest | PlainMessage<BatchGetCommentsRequest> | undefined): boolean {
    return proto3.util.equals(BatchGetCommentsRequest, a, b);
  }
}

/**
 * Response with multiple comments.
 *
 * @generated from message com.seed.documents.v3alpha.BatchGetCommentsResponse
 */
export class BatchGetCommentsResponse extends Message<BatchGetCommentsResponse> {
  /**
   * List of comments requested.
   *
   * @generated from field: repeated com.seed.documents.v3alpha.Comment comments = 1;
   */
  comments: Comment[] = [];

  constructor(data?: PartialMessage<BatchGetCommentsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.documents.v3alpha.BatchGetCommentsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "comments", kind: "message", T: Comment, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): BatchGetCommentsResponse {
    return new BatchGetCommentsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): BatchGetCommentsResponse {
    return new BatchGetCommentsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): BatchGetCommentsResponse {
    return new BatchGetCommentsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: BatchGetCommentsResponse | PlainMessage<BatchGetCommentsResponse> | undefined, b: BatchGetCommentsResponse | PlainMessage<BatchGetCommentsResponse> | undefined): boolean {
    return proto3.util.equals(BatchGetCommentsResponse, a, b);
  }
}

/**
 * Request to list comments.
 *
 * @generated from message com.seed.documents.v3alpha.ListCommentsRequest
 */
export class ListCommentsRequest extends Message<ListCommentsRequest> {
  /**
   * Required. Account ID to list the comments for.
   *
   * @generated from field: string target_account = 1;
   */
  targetAccount = "";

  /**
   * Required. Path within the account to list the comments for.
   *
   * @generated from field: string target_path = 2;
   */
  targetPath = "";

  /**
   * Optional. The maximum number of comments to return.
   *
   * @generated from field: int32 page_size = 3;
   */
  pageSize = 0;

  /**
   * Optional. The page token obtained from a previous request (if any).
   *
   * @generated from field: string page_token = 4;
   */
  pageToken = "";

  constructor(data?: PartialMessage<ListCommentsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.documents.v3alpha.ListCommentsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "target_account", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "target_path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "page_size", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "page_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListCommentsRequest {
    return new ListCommentsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListCommentsRequest {
    return new ListCommentsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListCommentsRequest {
    return new ListCommentsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListCommentsRequest | PlainMessage<ListCommentsRequest> | undefined, b: ListCommentsRequest | PlainMessage<ListCommentsRequest> | undefined): boolean {
    return proto3.util.equals(ListCommentsRequest, a, b);
  }
}

/**
 * Request to list comments by author.
 *
 * @generated from message com.seed.documents.v3alpha.ListCommentsByAuthorRequest
 */
export class ListCommentsByAuthorRequest extends Message<ListCommentsByAuthorRequest> {
  /**
   * Required. Account ID of the author to list comments for.
   *
   * @generated from field: string author = 1;
   */
  author = "";

  /**
   * Optional. The maximum number of comments to return.
   *
   * @generated from field: int32 page_size = 2;
   */
  pageSize = 0;

  /**
   * Optional. The page token obtained from a previous request (if any).
   *
   * @generated from field: string page_token = 3;
   */
  pageToken = "";

  constructor(data?: PartialMessage<ListCommentsByAuthorRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.documents.v3alpha.ListCommentsByAuthorRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "author", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "page_size", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "page_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListCommentsByAuthorRequest {
    return new ListCommentsByAuthorRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListCommentsByAuthorRequest {
    return new ListCommentsByAuthorRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListCommentsByAuthorRequest {
    return new ListCommentsByAuthorRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListCommentsByAuthorRequest | PlainMessage<ListCommentsByAuthorRequest> | undefined, b: ListCommentsByAuthorRequest | PlainMessage<ListCommentsByAuthorRequest> | undefined): boolean {
    return proto3.util.equals(ListCommentsByAuthorRequest, a, b);
  }
}

/**
 * Response with a list of comments.
 *
 * @generated from message com.seed.documents.v3alpha.ListCommentsResponse
 */
export class ListCommentsResponse extends Message<ListCommentsResponse> {
  /**
   * List of comments.
   *
   * @generated from field: repeated com.seed.documents.v3alpha.Comment comments = 1;
   */
  comments: Comment[] = [];

  /**
   * Token to retrieve the next page of comments (if necessary).
   *
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken = "";

  constructor(data?: PartialMessage<ListCommentsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.documents.v3alpha.ListCommentsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "comments", kind: "message", T: Comment, repeated: true },
    { no: 2, name: "next_page_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListCommentsResponse {
    return new ListCommentsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListCommentsResponse {
    return new ListCommentsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListCommentsResponse {
    return new ListCommentsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListCommentsResponse | PlainMessage<ListCommentsResponse> | undefined, b: ListCommentsResponse | PlainMessage<ListCommentsResponse> | undefined): boolean {
    return proto3.util.equals(ListCommentsResponse, a, b);
  }
}

/**
 * Comment is a unit of discussion.
 *
 * @generated from message com.seed.documents.v3alpha.Comment
 */
export class Comment extends Message<Comment> {
  /**
   * ID of the current comment.
   *
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * Account ID that this comment targets.
   *
   * @generated from field: string target_account = 2;
   */
  targetAccount = "";

  /**
   * Path within the account this comment targets.
   *
   * @generated from field: string target_path = 3;
   */
  targetPath = "";

  /**
   * Version of the document this comment targets.
   *
   * @generated from field: string target_version = 4;
   */
  targetVersion = "";

  /**
   * Optional. The ID of the top-level non-reply comment of the conversation thread.
   *
   * @generated from field: string thread_root = 5;
   */
  threadRoot = "";

  /**
   * Optional. Version of the thread root comment (if this is a reply).
   *
   * @generated from field: string thread_root_version = 12;
   */
  threadRootVersion = "";

  /**
   * Optional. The ID of the comment to which this comment is a direct reply.
   * For initial comments this field is empty.
   *
   * @generated from field: string reply_parent = 6;
   */
  replyParent = "";

  /**
   * Optional. Version of the parent comment (if this is a reply).
   *
   * @generated from field: string reply_parent_version = 13;
   */
  replyParentVersion = "";

  /**
   * Account ID of the author of the comment.
   *
   * @generated from field: string author = 7;
   */
  author = "";

  /**
   * Content of the comment.
   *
   * @generated from field: repeated com.seed.documents.v3alpha.BlockNode content = 8;
   */
  content: BlockNode[] = [];

  /**
   * Timestamp when the comment was created.
   *
   * @generated from field: google.protobuf.Timestamp create_time = 9;
   */
  createTime?: Timestamp;

  /**
   * Optional. ID of the capability this comment was created with, if any.
   *
   * @generated from field: string capability = 10;
   */
  capability = "";

  /**
   * Version of this comment.
   *
   * @generated from field: string version = 11;
   */
  version = "";

  /**
   * Timestamp when the comment was last updated.
   *
   * @generated from field: google.protobuf.Timestamp update_time = 14;
   */
  updateTime?: Timestamp;

  /**
   * Visibility of the comment, inherited from the target document at creation time.
   * Empty string means public visibility.
   *
   * @generated from field: string visibility = 15;
   */
  visibility = "";

  constructor(data?: PartialMessage<Comment>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.documents.v3alpha.Comment";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "target_account", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "target_path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "target_version", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "thread_root", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "thread_root_version", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "reply_parent", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "reply_parent_version", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "author", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "content", kind: "message", T: BlockNode, repeated: true },
    { no: 9, name: "create_time", kind: "message", T: Timestamp },
    { no: 10, name: "capability", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "version", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "update_time", kind: "message", T: Timestamp },
    { no: 15, name: "visibility", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Comment {
    return new Comment().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Comment {
    return new Comment().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Comment {
    return new Comment().fromJsonString(jsonString, options);
  }

  static equals(a: Comment | PlainMessage<Comment> | undefined, b: Comment | PlainMessage<Comment> | undefined): boolean {
    return proto3.util.equals(Comment, a, b);
  }
}

/**
 * Request to update a comment.
 *
 * @generated from message com.seed.documents.v3alpha.UpdateCommentRequest
 */
export class UpdateCommentRequest extends Message<UpdateCommentRequest> {
  /**
   * Required. Full snapshot of the updated comment record.
   * Clients should update objects received from GetComment or CreateComment calls.
   * The server will ignore output-only fields like timestamps.
   *
   * @generated from field: com.seed.documents.v3alpha.Comment comment = 1;
   */
  comment?: Comment;

  /**
   * Required. Name of the key to use for signing the comment update.
   *
   * @generated from field: string signing_key_name = 2;
   */
  signingKeyName = "";

  constructor(data?: PartialMessage<UpdateCommentRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.documents.v3alpha.UpdateCommentRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "comment", kind: "message", T: Comment },
    { no: 2, name: "signing_key_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateCommentRequest {
    return new UpdateCommentRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateCommentRequest {
    return new UpdateCommentRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateCommentRequest {
    return new UpdateCommentRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateCommentRequest | PlainMessage<UpdateCommentRequest> | undefined, b: UpdateCommentRequest | PlainMessage<UpdateCommentRequest> | undefined): boolean {
    return proto3.util.equals(UpdateCommentRequest, a, b);
  }
}

/**
 * Request to delete a comment.
 *
 * @generated from message com.seed.documents.v3alpha.DeleteCommentRequest
 */
export class DeleteCommentRequest extends Message<DeleteCommentRequest> {
  /**
   * Required. ID of the comment to delete.
   *
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * Required. Name of the key to use for signing the comment deletion.
   *
   * @generated from field: string signing_key_name = 2;
   */
  signingKeyName = "";

  constructor(data?: PartialMessage<DeleteCommentRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.documents.v3alpha.DeleteCommentRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "signing_key_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteCommentRequest {
    return new DeleteCommentRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteCommentRequest {
    return new DeleteCommentRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteCommentRequest {
    return new DeleteCommentRequest().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteCommentRequest | PlainMessage<DeleteCommentRequest> | undefined, b: DeleteCommentRequest | PlainMessage<DeleteCommentRequest> | undefined): boolean {
    return proto3.util.equals(DeleteCommentRequest, a, b);
  }
}

/**
 * Request to get the number of replies for a given comment.
 *
 * @generated from message com.seed.documents.v3alpha.GetCommentReplyCountRequest
 */
export class GetCommentReplyCountRequest extends Message<GetCommentReplyCountRequest> {
  /**
   * Required. ID of the comment to get replies for.
   * The ID must be a record ID (`{publicKey}/{tsid}`) of the comment.
   *
   * @generated from field: string id = 1;
   */
  id = "";

  constructor(data?: PartialMessage<GetCommentReplyCountRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.documents.v3alpha.GetCommentReplyCountRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetCommentReplyCountRequest {
    return new GetCommentReplyCountRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetCommentReplyCountRequest {
    return new GetCommentReplyCountRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetCommentReplyCountRequest {
    return new GetCommentReplyCountRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetCommentReplyCountRequest | PlainMessage<GetCommentReplyCountRequest> | undefined, b: GetCommentReplyCountRequest | PlainMessage<GetCommentReplyCountRequest> | undefined): boolean {
    return proto3.util.equals(GetCommentReplyCountRequest, a, b);
  }
}

/**
 * Response with the reply count for a comment.
 *
 * @generated from message com.seed.documents.v3alpha.GetCommentReplyCountResponse
 */
export class GetCommentReplyCountResponse extends Message<GetCommentReplyCountResponse> {
  /**
   * The number of replies to the comment.
   *
   * @generated from field: int64 reply_count = 1;
   */
  replyCount = protoInt64.zero;

  constructor(data?: PartialMessage<GetCommentReplyCountResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.documents.v3alpha.GetCommentReplyCountResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "reply_count", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetCommentReplyCountResponse {
    return new GetCommentReplyCountResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetCommentReplyCountResponse {
    return new GetCommentReplyCountResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetCommentReplyCountResponse {
    return new GetCommentReplyCountResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetCommentReplyCountResponse | PlainMessage<GetCommentReplyCountResponse> | undefined, b: GetCommentReplyCountResponse | PlainMessage<GetCommentReplyCountResponse> | undefined): boolean {
    return proto3.util.equals(GetCommentReplyCountResponse, a, b);
  }
}

/**
 * Request to list all versions of a comment.
 *
 * @generated from message com.seed.documents.v3alpha.ListCommentVersionsRequest
 */
export class ListCommentVersionsRequest extends Message<ListCommentVersionsRequest> {
  /**
   * Required. ID of the comment (record ID format: `{publicKey}/{tsid}`).
   *
   * @generated from field: string id = 1;
   */
  id = "";

  constructor(data?: PartialMessage<ListCommentVersionsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.documents.v3alpha.ListCommentVersionsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListCommentVersionsRequest {
    return new ListCommentVersionsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListCommentVersionsRequest {
    return new ListCommentVersionsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListCommentVersionsRequest {
    return new ListCommentVersionsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListCommentVersionsRequest | PlainMessage<ListCommentVersionsRequest> | undefined, b: ListCommentVersionsRequest | PlainMessage<ListCommentVersionsRequest> | undefined): boolean {
    return proto3.util.equals(ListCommentVersionsRequest, a, b);
  }
}

/**
 * Response with a list of comment versions.
 *
 * @generated from message com.seed.documents.v3alpha.ListCommentVersionsResponse
 */
export class ListCommentVersionsResponse extends Message<ListCommentVersionsResponse> {
  /**
   * All versions of the comment, ordered newest first.
   *
   * @generated from field: repeated com.seed.documents.v3alpha.Comment versions = 1;
   */
  versions: Comment[] = [];

  constructor(data?: PartialMessage<ListCommentVersionsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.seed.documents.v3alpha.ListCommentVersionsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "versions", kind: "message", T: Comment, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListCommentVersionsResponse {
    return new ListCommentVersionsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListCommentVersionsResponse {
    return new ListCommentVersionsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListCommentVersionsResponse {
    return new ListCommentVersionsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListCommentVersionsResponse | PlainMessage<ListCommentVersionsResponse> | undefined, b: ListCommentVersionsResponse | PlainMessage<ListCommentVersionsResponse> | undefined): boolean {
    return proto3.util.equals(ListCommentVersionsResponse, a, b);
  }
}

